export const Colors: string[] = [
  "green",
  "red",
  "blue",
  "yellow",
  "indigo",
  "purple",
  "pink",
]
